var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookPostLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FB-like") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FB-like",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,17 L2,9 C2,8.44771525 2.44771525,8 3,8 L6,8 C6.55228475,8 7,8.44771525 7,9 L7,17 C7,17.5522847 6.55228475,18 6,18 L3,18 C2.44771525,18 2,17.5522847 2,17 Z",
    id: "Path-3",
    stroke: "#606770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,10 L7.86102076,9.08969499 C8.5531518,7.97686787 9.05580857,6.80657509 9.36899107,5.57881666 C9.55845855,4.83605391 9.52546079,2.59308619 9.78466066,2.4433164 C10.7663868,1.87605951 11.403243,1.82886701 12.1050807,2.4433164 C12.2408056,2.53228155 13.2115394,3.57943142 13.4204169,4.32447356 C13.5596685,4.82116832 13.7352934,6.1230607 13.7090982,7.20132665 L17.324977,7.20135809 C17.4939822,7.20135809 17.6591739,7.25080415 17.7995685,7.34341536 C18.4289323,7.7585749 18.7436143,8.22558602 18.7436143,8.74444874 C18.7436143,9.32337355 18.670093,9.84576036 18.5230504,10.3116092 C18.8410168,10.6958038 19,11.1490874 19,11.6714599 C19,12.1938325 18.6926672,12.7102805 18.0780017,13.2208039 C18.1476167,13.7771237 18.1044566,14.2631029 17.9485214,14.6787415 C17.7925862,15.0943801 17.4139611,15.4594245 16.812646,15.7738746 C16.8001181,16.1661578 16.7575348,16.4985135 16.6848962,16.7709419 C16.6238789,16.999785 16.3831393,17.3254798 15.9626775,17.7480264 C15.8023176,17.9091809 15.5827963,18 15.3536247,18 L8.62179436,18 C8.29981751,18 7.99753692,17.8449685 7.80966894,17.5834829 L7,16.4565386 L7,10 Z",
    id: "Path-4",
    stroke: "#606770"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    strokeOpacity: 0,
    stroke: "#979797",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookPostLike);
export default __webpack_public_path__ + "static/media/facebook-post-like.65c3808a0a7cda795b0c2d1257745361.svg";
export { ForwardRef as ReactComponent };